<template>
	<el-header class='header'>
		<div class='title'>
			<div class='title_left'>
				<p class="title_name">{{config.systemName}}</p>
				<p class="title_time">{{time}}</p>
				<!-- <p class="title_time">2018-06-21 16:51:30 周五</p> -->
			</div>
			<div class='title_right'>
				<admin></admin>
			</div>
		</div>
	
		<tags></tags>

	</el-header>
</template>

<script scoped>
	import {config} from '../config/config'
	import Admin from '@/views/layout/components/Admin'
	import Tags from '@/views/layout/components/Tabs'
	export default {
		name: 'headerBar',
		components: {
			Admin,
			Tags
		},
		data() {
			return {
				config: config,
				time: ''
			}
		},
		mounted() {
			this.$nextTick(function () {
				this.getTime()
			})
		},
		methods: {
			getTime() {
				let _this = this
				setInterval(function(){
					_this.time = _this.$moment().format('YYYY-MM-DD HH:mm:ss')
						+' 星期' + '日一二三四五六'.charAt(new Date().getDay())
				},1000)
			}
		}
	}
</script>

<style type="text/less" lang="less" scoped>
	@border_color: #E7EBEF;
	.header{
		height: auto!important;
		padding: 0;
		border: 1px solid @border_color;
	}
	.title{
		width: 100%;
		display: flex;
		box-sizing: border-box;
		height: 80px;
		border-bottom: 1px solid @border_color;
		padding: 0 30px;
		.title_left{
			flex: 1;
			text-align: left;
		}
		.title_right{
			position: relative;
		}
	}
	.title_name{
		font-size: 16px;
		color: #465974;
		margin-bottom: 2px;
	}
	.title_time{
		font-size: 12px;
		color: #9b9b9b;
		margin-top: 2px;
	}
</style>


// WEBPACK FOOTER //
// src/views/layout/components/Header.vue